<his-dialog-header [showCustomButton]="showEditButton && hasEditRights" [customButtonLabel]="'common.edit'"
	[showResetButton]="false" [showSaveButton]="false" [showBackButton]="showBackButton" [showSearchButton]="showSearchButton" 
	(customEvent)="edit()">
	<!-- Bedienelemente im "Mehr..." -->
	<ng-container customButtons>
		<his-display-webshare [btnTitle]="'cs.sys.webshare.patent'" [title]="patent.title" [text]="patent.title"
			[url]="getUrl()"></his-display-webshare>
	</ng-container>
</his-dialog-header>

<div *ngIf="patent.id" class="layoutBlock detailpage">
	<div class="detailpageSideLeft">
		<div class="circleIconContainer">
			<div class="circle-icon">
				<div>
					<img hisImage="PATENT" class="inlineicon" title="{{ 'fs.res.patent' | hisUi }}">
				</div>
			</div>
		</div>
	</div>
	<div class="detailpageCenter">
		<res-patent-view-vcard [patent]="patent"> </res-patent-view-vcard>

		<res-collapsible-text-view [text]="patent | hisTranslate : 'commentary'" 
		      [hisobject]="patent" 
		      [hisAttribute] ="'commentary'"
		      header="fs.res.patent.Patent.commentary"
			expandToolTip="fs.res.patent.view.showFullCommentary"
			collapseToolTip="fs.res.patent.view.showShortCommentary">{{patent.commentary}}
		</res-collapsible-text-view>

		<br> <br>
		<div class="details">
			<div class="detailPresentationList">
				<div *ngIf="!isRegistered() && patent.registrationDate" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel">
						<span>{{'fs.res.patent.Patent.registrationDate' | hisUi}}</span>
					</div>
					<div class="columnDetailContent detailPresentationListContent">
						<span> {{patent.registrationDate | date: dateFormat}} </span>
					</div>
				</div>
				<div *ngIf="!isRegistered() && patent.patentNumber" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel">
						<span>{{'fs.res.patent.Patent.patentNumber' | hisUi}}</span>
					</div>
					<div class="columnDetailContent detailPresentationListContent">
						<span> {{patent.patentNumber}} </span>
					</div>
				</div>
				<div *ngIf="!isGranted() && patent.grantDate" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel">
						<span>{{'fs.res.patent.Patent.grantDate' | hisUi}}</span>
					</div>
					<div class="columnDetailContent detailPresentationListContent">
						<span> {{patent.grantDate | date: dateFormat}} </span>
					</div>
				</div>
				<div *ngIf="!isPublished() && patent.publicationNumber" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel">
						<span>{{'fs.res.patent.Patent.publicationNumber' | hisUi}}</span>
					</div>
					<div class="columnDetailContent detailPresentationListContent">
						<span> {{patent.publicationNumber}} </span>
					</div>
				</div>

				<!-- SubjectAreas -->
				<div *ngIf="patentForDetailView.subjectAreas?.length > 0" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel">
						<span>{{'value.SubjectAreaValue' | hisUi}}</span>
					</div>
					<div class="columnDetailContent detailPresentationListContent wordBreak">
						<span *ngFor="let subjectArea of patentForDetailView.subjectAreas">
							<a [routerLink]="['/patent/all/searchresult']"
								[queryParams]="{configFile: 'fs/res/searchPatentHeadless.xml', pageTitle: 'fs.res.patent.search.header',
									tableTitle: 'fs.res.patent.search.found', 'extended': true, 'COALESCE(Patent.subjectAreaValues.id,Patent.priorityPatent.subjectAreaValues.id)[]': getGenericValueIdForQueryParams(subjectArea), showBackButton:true, isNotActiveSearch:true}"
								hisImage="TAG_ORANGE"
								class="transparent"
								title="{{ 'fs.res.common.showResearchObjectsWithSubjectArea' | hisUi:('fs.res.common.patents' | hisUi | hisLowerCaseFirstLetter) : subjectArea.text }}"
								(click)="onBeforeNavigate()">{{ subjectArea.text }}</a>
						</span>
					</div>
				</div>

                <!-- ResearchAreasKdsf -->
                <div *ngIf="patentForDetailView.researchAreasKdsf?.length > 0" class="layoutBlock detailPresentationListItem">
                    <div class="columnDetailLabel detailPresentationListLabel">
                        <span>{{'fs.res.common.researchAreasKdsf' | hisUi}}</span>
                    </div>
                    <div class="columnDetailContent detailPresentationListContent wordBreak">
                        <span *ngFor="let researchAreaKdsf of patentForDetailView.researchAreasKdsf">
                            <a [routerLink]="['/patent/all/searchresult']"
                                [queryParams]="getResearchAreaKdsfQueryParams(researchAreaKdsf)"
                                hisImage="tag_orange" class="transparent"
                                title="{{ 'fs.res.common.showResearchObjectsWithResearchAreaKdsf'|hisUi:('fs.res.common.patents' | hisUi | hisLowerCaseFirstLetter):researchAreaKdsf.text }}"
                                (click)="onBeforeNavigate()">{{researchAreaKdsf.text}}</a>
                        </span>
                    </div>
                </div>

                <!-- ResearchAreas -->
                <div *ngIf="patentForDetailView.researchAreas?.length > 0" class="layoutBlock detailPresentationListItem">
                    <div class="columnDetailLabel detailPresentationListLabel">
                        <span>{{'value.ResearchAreaValue' | hisUi}}</span>
                    </div>
                    <div class="columnDetailContent detailPresentationListContent wordBreak">
                        <span *ngFor="let researchArea of patentForDetailView.researchAreas">
                            <a [routerLink]="['/patent/all/searchresult']"
                                [queryParams]="getResearchAreaQueryParams(researchArea)"
                                hisImage="tag_orange" class="transparent"
                                title="{{ 'fs.res.common.showResearchObjectsWithResearchArea'|hisUi: ('fs.res.common.patents' | hisUi | hisLowerCaseFirstLetter):researchArea.text }}"
                                (click)="onBeforeNavigate()">{{researchArea.text}}</a>
                        </span>
                    </div>
                </div>
			</div>
		</div>
	</div>
	<!--Platzhalter für leere rechte Spalte-->
	<div class="detailpageSideRight"></div>
</div>

<!-- HIS-Listview, wenn Listview gefüllt in patent-->
<ng-container *ngIf="patent.listviews">
	<his-listview [listviewKeys]="['patents', 'projects']" [listviewData]="patent.listviews"></his-listview>
</ng-container>
